// extracted by mini-css-extract-plugin
export var borderRadius = "_b9-4";
export var large = "_b9-3";
export var logoContainer = "_b9-0";
export var nameLogo = "_b9-2";
export var small = "_b9-1";